import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  clearCampaignCreditStatus,
  peekCampaignCreditStatus,
} from "utils/campaignCredit";
import "styles/campaign-credit-toast.css";

/** Bottom-right status toast (same pattern as admin booking updates). */
const CampaignCreditStatusToast = () => {
  const location = useLocation();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const next = peekCampaignCreditStatus();
    if (next) setStatus(next);
  }, [location.pathname, location.search]);

  if (!status?.message) return null;

  const dismiss = () => {
    clearCampaignCreditStatus();
    setStatus(null);
  };

  return (
    <div
      className="campaign-credit-toast"
      role="region"
      aria-label="Aktionsstatus"
    >
      <div className="campaign-credit-toast__header">
        <span>Aktionsstatus</span>
        <button
          type="button"
          className="campaign-credit-toast__clear"
          onClick={dismiss}
        >
          Schließen
        </button>
      </div>
      <ul className="campaign-credit-toast__list">
        <li>
          <div className="campaign-credit-toast__card">
            <span className="campaign-credit-toast__text">{status.message}</span>
          </div>
          <button
            type="button"
            className="campaign-credit-toast__dismiss"
            onClick={dismiss}
            aria-label="Benachrichtigung schließen"
          >
            ×
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CampaignCreditStatusToast;
